import(/* webpackMode: "eager" */ "/vercel/path0/app/(assets)/logo_rectangle_white_highres.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/LanguageControl.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/PrimaryServiceNavItems.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/quizzes/BusQuizRunner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/quizzes/Quiz.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/WhatsAppButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/katex/dist/katex.min.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
